import type { Theme } from '@mui/material/styles';

export const radiusValue = (theme: Theme, factor = 1) =>
  typeof theme.shape.borderRadius === 'number'
    ? theme.shape.borderRadius * factor
    : `calc(${theme.shape.borderRadius} * ${factor})`;
